<div class="form-section" [ngClass]="config?.className">
	<div class="form-section--wrapper"
		[ngClass]="{'form-section--fixed-height': config?.formSectionType === FormSectionType.FIXED_HEIGHT}">
		<ng-content></ng-content>
	</div>
	<div class="action-bar"
		[ngClass]="{'action-bar--sticky': config?.formSectionType === FormSectionType.STICKY}">
		<angie-action-bar
			[config]="config?.actionBarConfig">
		</angie-action-bar>
	</div>
</div>
